// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const FilterIcon = (props: IconProps) => (
  <Icon viewBox="0 0 48 48" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4916 14.3067C17.5213 14.3067 16.7169 15.1091 16.7169 16.1067C16.7169 17.1044 17.5213 17.9067 18.4916 17.9067H18.5421C19.5125 17.9067 20.3169 17.1044 20.3169 16.1067C20.3169 15.1091 19.5125 14.3067 18.5421 14.3067H18.4916ZM15.3169 16.1067C15.3169 14.3493 16.7347 12.9067 18.4916 12.9067H18.5421C20.2991 12.9067 21.7169 14.3493 21.7169 16.1067C21.7169 17.8642 20.2991 19.3067 18.5421 19.3067H18.4916C16.7347 19.3067 15.3169 17.8642 15.3169 16.1067Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.5122 30.3738C22.5418 30.3738 21.7374 31.1761 21.7374 32.1738C21.7374 33.1714 22.5418 33.9738 23.5122 33.9738H23.5627C24.533 33.9738 25.3374 33.1714 25.3374 32.1738C25.3374 31.1761 24.533 30.3738 23.5627 30.3738H23.5122ZM20.3374 32.1738C20.3374 30.4163 21.7552 28.9738 23.5122 28.9738H23.5627C25.3196 28.9738 26.7374 30.4163 26.7374 32.1738C26.7374 33.9312 25.3196 35.3738 23.5627 35.3738H23.5122C21.7552 35.3738 20.3374 33.9312 20.3374 32.1738Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.5331 22.3403C27.5628 22.3403 26.7584 23.1426 26.7584 24.1403C26.7584 25.138 27.5628 25.9403 28.5331 25.9403H28.5836C29.554 25.9403 30.3584 25.138 30.3584 24.1403C30.3584 23.1426 29.554 22.3403 28.5836 22.3403H28.5331ZM25.3584 24.1403C25.3584 22.3829 26.7762 20.9403 28.5331 20.9403H28.5836C30.3406 20.9403 31.7584 22.3829 31.7584 24.1403C31.7584 25.8977 30.3406 27.3403 28.5836 27.3403H28.5331C26.7762 27.3403 25.3584 25.8977 25.3584 24.1403Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.6807 24C30.6807 23.6134 30.9941 23.3 31.3807 23.3H34.0418C34.4284 23.3 34.7418 23.6134 34.7418 24C34.7418 24.3866 34.4284 24.7 34.0418 24.7H31.3807C30.9941 24.7 30.6807 24.3866 30.6807 24Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2583 24C13.2583 23.6134 13.5717 23.3 13.9583 23.3H25.7073C26.0939 23.3 26.4073 23.6134 26.4073 24C26.4073 24.3866 26.0939 24.7 25.7073 24.7H13.9583C13.5717 24.7 13.2583 24.3866 13.2583 24Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.8608 32.0335C25.8608 31.6469 26.1742 31.3335 26.5608 31.3335H34.042C34.4286 31.3335 34.742 31.6469 34.742 32.0335C34.742 32.4201 34.4286 32.7335 34.042 32.7335H26.5608C26.1742 32.7335 25.8608 32.4201 25.8608 32.0335Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2583 32.0335C13.2583 31.6469 13.5717 31.3335 13.9583 31.3335H20.6863C21.0729 31.3335 21.3863 31.6469 21.3863 32.0335C21.3863 32.4201 21.0729 32.7335 20.6863 32.7335H13.9583C13.5717 32.7335 13.2583 32.4201 13.2583 32.0335Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6392 15.9666C20.6392 15.58 20.9526 15.2666 21.3392 15.2666H34.0421C34.4287 15.2666 34.7421 15.58 34.7421 15.9666C34.7421 16.3532 34.4287 16.6666 34.0421 16.6666H21.3392C20.9526 16.6666 20.6392 16.3532 20.6392 15.9666Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2583 15.9666C13.2583 15.58 13.5717 15.2666 13.9583 15.2666H15.7658C16.1524 15.2666 16.4658 15.58 16.4658 15.9666C16.4658 16.3532 16.1524 16.6666 15.7658 16.6666H13.9583C13.5717 16.6666 13.2583 16.3532 13.2583 15.9666Z"
      fill="currentColor"
    />
  </Icon>
);
